/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flavor_NameInputs */

const en_flavor_name = /** @type {(inputs: Flavor_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flavor name`)
};

const es_flavor_name = /** @type {(inputs: Flavor_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del sabor`)
};

/**
* | output |
* | --- |
* | "Flavor name" |
*
* @param {Flavor_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const flavor_name = /** @type {((inputs?: Flavor_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flavor_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flavor_name(inputs)
	return es_flavor_name(inputs)
});